module.exports = __webpack_public_path__ + "static/phuong-6ed0f10423af1b54d602d92d60de9183.jpg";